var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fin-avatar',{attrs:{"avatar-image-style":_vm.avatarImageStyle,"disable-tooltip":_vm.disableTooltip,"item":_vm.item}})}
var staticRenderFns = []

export { render, staticRenderFns }